import React from "react";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Footer } from "antd/es/layout/layout";
import { Container, Row, Col, Form, Spinner } from "react-bootstrap";
import { ProductCardList } from "../../../../../sharedComponents/ProductCardList";
import { InputField } from "../../../../../sharedComponents/InputField";
import { SharedSelect } from "../../../../../sharedComponents/SharedSelect";
import { SharedButton } from "../../../../../sharedComponents/Button";
import { TextArea } from "../../../../../sharedComponents/TextArea";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { products_details, update_product, update_product_image } from "../../../../../Studio-Services/Studio_Services";
import Swal from "sweetalert2";
import logo from "../../../../../Images/logo_white_web.png"
import { errorAlert } from "../../../../../Static_Services/Alertmsg";

export const Productupdate = () => {
  const [pData, setPData] = useState();
  const [pd, setPd] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [imgURL, setImgURL] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const uploadImage = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      setSelectedFile(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        setImgURL(event.target.result);
      };
    }
  };

  const productsDetails = async () => {
    if (pData && pData.product_id) {
      const fData = {
        "product_id": pData.product_id
      }
      const resp = await products_details(fData);
      if (resp) {
        setPd(resp.data.data);
      }
    }
  }

  useEffect(() => {
    if (pData) {
      productsDetails();
    }

  }, [pData])

  useEffect(() => {
    if (location) {
      setPData(location.state.data);
    }
  }, [location])

  const Stopt = [
    { value: "Active", label: "Visible" },
    { value: "Disable", label: "Not Visible" }
  ]


  const submitHandler = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formValue = Object.fromEntries(formData.entries());

    const fData = {
      "product_id": formValue.product_id,
      "product_price": formValue.product_price,
      "quantity": formValue.quantity,
      "status": formValue.status,
      "description": formValue.description
    }

    const resp = await update_product(fData);
    if (resp) {
      Swal.fire({
        html: `
      <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
      <h4 class="title text-capitalize text-center mt-4 textWhite">Success</h4>
      <p class="text-center my-4 textcolor">
        <small class="textWhite">${resp.data.message}</small>
      </p>
    `,
        showClass: {
          popup: 'custom-dialog-container',
        },
        customClass: {
          confirmButton: 'custom-button custom-button-size modalbtn',
        },
        confirmButtonText: 'Continue',
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirect to a new page
          navigate("/list-products");
        }
      });
    }

  }


  const uploadImg = async () => {
    var formData = new FormData();
    const product_image_id = pd?.product_images[0]?.product_image_id;
    const product_id = pd?.product_id;

    if (!product_image_id) { errorAlert("Product Image ID is missing"); return; }
    if (!product_id) { errorAlert("Product ID is missing"); return; }
    if (selectedFile) {
      formData.append('product_id', product_id);
      formData.append('product_image_id', product_image_id);
      formData.append('product_images[]', selectedFile);
    } else {
      errorAlert("Please select file"); return;
    }
    setLoader(true);

    try {
      const resp = await update_product_image(formData);
      if (resp) {
        Swal.fire({
          html: `
      <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
      <h4 class="title text-capitalize text-center mt-4 textWhite">Success</h4>
      <p class="text-center my-4 textcolor">
        <small class="textWhite">${resp.data.message}</small>
      </p>
    `,
          showClass: {
            popup: 'custom-dialog-container',
          },
          customClass: {
            confirmButton: 'custom-button custom-button-size modalbtn',
          },
          confirmButtonText: 'Continue',
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirect to a new page
            // navigate("/list-products");
            setImgURL(null);
            productsDetails();
          }
        });
      }
    } catch (error) {

    } finally {
      setLoader(false);
    }
  }

  return (
    <>
      {loader && <div className='MainLoader'> <Spinner animation="border" role="status" className='Loader'> <span className="visually-hidden">Loading...</span>  </Spinner> </div>}
      <div className="MainDashboard">
        <div className="MainLayout">
          <Row>

            <Sidebar />
            <Col className="p-0 RightCol">
              <HeaderDashboard />
              <div className="RightSide">
                <section className="addClient innerContent">
                  <Container className="pt-5 my-3">
                    <div className="ProductUpdateBg ">
                      <Row >
                        <Col lg={3} xs={12}>
                          <div className="productimg" style={{ textAlign: 'center', justifyContent: 'center' }}>
                            <h3>PRODUCT'S IMAGE</h3>

                            <div className="form-group">
                              <div className="custom-uploadfile mb-3" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                {!imgURL &&
                                  <button className="fileuploadlabel" type="button">
                                    <img
                                      src={pd && pd.product_images[0] && pd.product_images[0].image_name ? pd.product_images[0].image_name : "https://warriorsms.com/superadmin/uploads/products/1652214051WarriorMan_icon2_CMYK.png"}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </button>
                                }
                                {imgURL &&
                                  <button className="fileuploadlabel" type="button">
                                    <img
                                      src={imgURL}
                                      className="img-fluid"
                                      style={{ height: "100px" }}
                                      alt=""
                                    />
                                    <span className="d-block font-14">Change image </span>
                                  </button>
                                }
                                <input type="file" className="fileuploadinput" accept="image/x-png,image/gif,image/jpeg"
                                  formControlName="profileimg" onChange={(e) => uploadImage(e)} />
                              </div>
                            </div>
                            {/* <img
                              src={pd && pd.product_images[0] && pd.product_images[0].image_name ? pd.product_images[0].image_name : "https://warriorsms.com/superadmin/uploads/products/1652214051WarriorMan_icon2_CMYK.png"}


                              alt=""
                              className="img-fluid"
                            /> */}

                            <Row style={{ justifyContent: 'center', alignItems: 'center' }}>
                              <Col className={imgURL ? "col-md-6" : 'col-md-9'}>
                                <SharedButton
                                  title={"update"}
                                  className={"btn btn-primary w-100 py-1 px-1"}
                                  variant={"primary"}
                                  onClick={() => { uploadImg() }}
                                />
                              </Col>
                              {imgURL &&
                                <Col className="col-md-6">
                                  <SharedButton
                                    title={"cancel"}
                                    className={"btn btn-danger w-100"}
                                    variant={"danger"}
                                    onClick={() => { setImgURL(null) }}
                                  />
                                </Col>
                              }
                            </Row>
                          </div>
                        </Col>
                        <Col lg={9} xs={12}>
                          <div className="ListProductForm">
                            <h3 className="mb-5">PRODUCT DETAILS</h3>
                            <Form onSubmit={submitHandler}>
                              <Row>
                                <Col>
                                  <div className="ProductDetails">
                                    <h3>{pd && pd.product_name ? pd.product_name : ""}</h3>
                                    <h5>Product No.: {pd && pd.product_id ? pd.product_id : ""}</h5>
                                    <h3>Price : <span className="pricegreen">$ {pd && pd.product_price ? pd.product_price : ""}</span></h3>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mt-4">
                                <h3>UPDATE PRODUCT DETAILS</h3>
                                <Col>
                                  <InputField
                                    type={"text"}
                                    lable={"Product ID"}
                                    name="product_id"
                                    readOnly
                                    value={pd && pd.product_id ? pd.product_id : ""}
                                  />
                                </Col>
                                <Col>
                                  <InputField
                                    type={"number"}
                                    name={"quantity"}
                                    value={pd && pd.product_quantity ? pd.product_quantity : ""}
                                    lable={"Quantity"}
                                  />
                                </Col>
                              </Row>
                              <Row className="mt-4">
                                <Col>
                                  <InputField
                                    type={"text"}
                                    name={"product_price"}
                                    lable={"Total Price"}
                                    value={pd && pd.product_price ? pd.product_price : ""}
                                  />
                                </Col>
                                <Col>
                                  <SharedSelect
                                    name={"status"}
                                    lable={"Status"}
                                    value={pd && pd.product_status ? pd.product_status : ""}
                                    options={Stopt}
                                  />
                                </Col>
                              </Row>
                              <Row className="mt-3">
                                <Col>
                                  <TextArea
                                    name={"description"}
                                    value={pd && pd.product_description ? pd.product_description : ""}
                                    lable={"Description"} />
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <SharedButton
                                    title={"Update"}
                                    className={"btn btn-primary w-100"}
                                    variant={"primary"}
                                  />
                                </Col>
                                <Col>
                                </Col>
                                <Col></Col>
                              </Row>
                            </Form>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Container>
                </section>
                <Footer />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
